window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];

export default window.pbjs;
